import ApiService from '../api/ApiService';

export default async function greyCradReader(body, recordId) {
  const { data } = await ApiService('greyCradReader', { recordId }, null, body, null, null, null);

  return data;
}
